<template>
    <span>

        <v-navigation-drawer app v-model="drawer" class="brown lighten-2" dark disable-resize-watcher>
            <v-layout column align-center>
                <v-flex class="mt-5">
                    <v-avatar size="130">
                        <img src='@/assets/avatar-female.png' alt="i"/>
                    </v-avatar>
                    <p class="white--text subheading mt-1">
                        The Campus cinema
                    </p>
                </v-flex>   
            </v-layout>
            <v-list>
                <template v-for="(item, index) in items">
                    <v-list-tile :key="index" :to='item.route'>
                        <v-list-tile-content>
                           
                            {{item.title}}
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider :key="`divider-${index}`"></v-divider>
                </template>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar app color="brown darken-4" dark>
            <v-toolbar-side-icon class="" @click="drawer = !drawer"></v-toolbar-side-icon>
            <v-spacer class="hidden-md-and-up"></v-spacer>
            <v-toolbar-title>{{appTitle}}</v-toolbar-title>
            <v-btn flat class="hidden-sm-and-down">The campus cinema</v-btn>
            <v-spacer class="hidden-sm-and-down"></v-spacer>
            <span class="icon-top">
            <i class="material-icons" title="Edit details">person</i>
            <i class="material-icons" title="Logout">settings_power</i>
             </span>
                        
        </v-toolbar>
    </span>
</template>

<script>
export default {
    name: 'AppNavigation',
    data() {
        return {
            appTitle: 'Exodus',
            drawer: true,
            items: [
                { title: 'Dashboard',route:'/home'},
                { title: 'Tickets',route:'/tickets' },
                { title: 'Refreshment' ,route:'/refreshments'},
                { title: 'Rights' ,route:'/rights'},
                { title: 'Campus' ,route:'/campus'},
                { title: 'Watch Now' ,route:'/watch'},
                { title: 'Staffs' ,route:'/staff'},
                { title: 'Logout' ,route:'/'}
            ]
        };
    }
};
</script>

<style scoped>
.icon-top i{
	padding:5px;
}
a:visited,a{
	text-decoration:none;
	color:white;
}
</style>